import { useState } from 'react'
import type { Vehicle, VehicleImage as VehicleImageData, VehicleImageView } from '../../data/vehicles'
import type { InventoryMessageKey } from './messages'
import { useInventoryTranslation } from './useInventoryTranslation'

const altKeys: Record<VehicleImageView, InventoryMessageKey> = {
  detail: 'imageDetail',
  front: 'imageFront',
  frontThreeQuarter: 'imageFrontThreeQuarter',
  rear: 'imageRear',
  rearThreeQuarter: 'imageRearThreeQuarter',
}

export function vehicleLabel(vehicle: Vehicle) {
  return `${vehicle.make} ${vehicle.model}`
}

export function VehicleImage({
  vehicle,
  image,
  className,
  eager = false,
}: {
  vehicle: Vehicle
  image?: VehicleImageData
  className: string
  eager?: boolean
}) {
  const { t } = useInventoryTranslation()
  const [failedSource, setFailedSource] = useState<string | null>(null)
  const failed = !image || failedSource === image.src

  if (failed) {
    return (
      <div className={`${className} vehicle-image-fallback`} role="img" aria-label={t('imageUnavailable')}>
        <span className="vehicle-image-fallback__line" aria-hidden="true" />
        <span>{t('imageUnavailable')}</span>
      </div>
    )
  }

  return (
    <img
      className={className}
      src={image.src}
      alt={t(altKeys[image.view], { vehicle: vehicleLabel(vehicle) })}
      width="1195"
      height="896"
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : 'auto'}
      decoding="async"
      style={{ objectPosition: image.focalPoint }}
      onError={() => setFailedSource(image.src)}
    />
  )
}
